<template>
  <div class="app-container">
    <navigation :navName="nav"></navigation>
    <div class="remark">未分类配置项：{{ sum }}</div>
    <!--表格-->
    <div class="table-container">
      <el-button size="mini"
                 type="primary"
                 @click="goToEdit()">添加栏目</el-button>
      <table-box :data="columnList"
                 ref="table"
                 :expandAll="expandAll"
                 :tableHeight="tableHeight"
                 id="rebateSetTable">
        <table-column prop="name"
                      label="栏目名称"> </table-column>
        <table-column prop="num"
                      label="配置项"> </table-column>
        <table-column label="更新时间"
                      :formatter="formatSetDate"> </table-column>
        <table-column prop="editors"
                      label="编辑人"> </table-column>
        <table-column label="操作"
                      :width="'160px'"
                      alignType="left">
          <template slot-scope="scope">
            <span class="table-btn"
                  @click="_edit(scope.row)">编辑</span>
            <span class="table-btn"
                  @click="_detail(scope.row)">内容配置</span>
            <span class="table-btn delete"
                  v-if="!scope.row.have_page"
                  @click="_delete(scope.row)">删除</span>
          </template>
        </table-column>
      </table-box>
      <!-- <pagination @currentChange="handleCurrentChange"
                  @sizeChange="handleSizeChange"
                  :currentPage.sync="searchForm.page"
                  :pageSize.sync="searchForm.per_page"
                  :total="total">
      </pagination> -->
    </div>
    <!-- <div class="table-top">
      <div class="remark">未分类配置项：{{ sum }}</div> -->
    <!-- <div class="btn">
        <el-button type="primary"
                   @click="goToEdit()">添加栏目</el-button>
      </div> -->
    <!-- </div> -->
    <!-- <el-table :data="columnList"
              :expandAll="expandAll"
              border>
      <el-table-column label="栏目名称"
                       width='150px'>
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
        </template>
      </el-table-column>
      <el-table-column label="配置项"
                       width='80px'>
        <template slot-scope="scope">
          <span>{{scope.row.num}}</span>
        </template>
      </el-table-column>
      <el-table-column label="更新时间"
                       width='160px'
                       :formatter="formatSetDate">
      </el-table-column>
      <el-table-column label="编辑人"
                       width='100px'>
        <template slot-scope="scope">
          <span>{{scope.row.editors}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click="_edit(scope.row)"
                     type="primary">编辑</el-button>
          <el-button @click="_delete(scope.row)"
                     type="primary">删除</el-button>
          <el-button @click="_detail(scope.row)"
                     type="primary">内容配置</el-button>
        </template>
      </el-table-column>
    </el-table> -->
  </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
import api from '../../api/api';
import navigation from '../websiteConfig/navigation';


export default {
  name: 'treeTableDemo',
  components: { navigation },
  data() {
    return {
      expandAll: true,
      columnList: [],
      nav: '',
      tableHeight: 0,
      loading: true,
      sum: 0,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.tableHeight =
        document.documentElement.clientHeight - this.$refs.table.$el.offsetTop - 85;
    });
    const that = this;
    that.$store.commit('changeLoading', true);
    axios
      .get(`${api.url}getColumnList`, { params: { wid: this.$store.state.websiteId } })
      .then((response) => {
        const data = response.data;
        if (data.ret === 0) {
          let num = 0;
          this.columnList = data.content;
          for (let i = 0; i < this.columnList.length; i += 1) {
            num += this.columnList[i].num;
          }
          axios
            .get(`${api.url}getConfigNum`, { params: { wid: this.$store.state.websiteId } })
            .then((res) => {
              const configData = res.data;
              if (configData.ret === 0) {
                this.sum = configData.num - num;
              }
            })
            .catch(() => {

            });
        }
      })
      .catch(() => {

      });
  },
  methods: {
    formatSetDate(row) {
      return moment(new Date(row.updateTime)).format('YYYY-MM-DD HH:mm:ss');
    },
    _edit(data) {
      // eslint-disable-next-line no-underscore-dangle
      const columnId = data._id;
      const _ = this;
      _.$store.commit('getColumnId', columnId);
      localStorage.setItem('columnId', columnId);
      this.$router.push({
        path: 'addColumn',
      });
    },
    _detail(resData) {
      // eslint-disable-next-line no-underscore-dangle
      const columnId = resData._id;
      const wName = resData.name;
      const _ = this;
      _.$store.commit('getColumnName', wName);
      localStorage.setItem('columnName', wName);
      _.$store.commit('getColumnId', columnId);
      localStorage.setItem('columnId', columnId);
      _.$router.push({
        path: 'websiteDetail',
      });
    },
    goToEdit() {
      if (this.sum === 0) {
        this.$message({
          message: '已经没有可分类的配置项~',
          type: 'warning',
        });
        return;
      }
      this.$store.commit('getColumnId', '');
      localStorage.setItem('columnId', '');
      this.$router.push({
        path: 'addColumn',
      });
    },
    _delete(data) {
      // eslint-disable-next-line no-underscore-dangle
      const id = data._id;
      this.$confirm('此操作将永久删除该栏目, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        axios
          .get(`${api.url}deleteColumn`, {
            params: {
              id,
            },
          })
          .then((response) => {
            const columnData = response.data;
            if (columnData.ret === 0) {
              this.$message({
                message: '删除成功~',
                type: 'success',
              });
              location.reload();
            }
          });
      });
    },
  },
};
</script>
<style scoped>
.table-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.remark {
  height: 32px;
  line-height: 32px;
  padding: 0 50px 0 10px;
  background: #e9f2fd;
  color: #666;
  border-radius: 2px;
  margin: 8px 0;
}
h2 {
  line-height: 50px;
}
.btn {
  display: flex;
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/columnConfig/columnConfig.vue